import { type ReactNode } from "react";

import { cn } from "@/lib/utils";

interface InfoItemProps {
  icon: ReactNode;
  label: string;
  value: ReactNode;
  className?: string;
}

/**
 * A labelled value with a leading icon, used to present read-only detail
 * fields consistently across the app (trial details, payment details, ...).
 */
export const InfoItem = ({ icon, label, value, className }: InfoItemProps) => (
  <div
    className={cn(
      "group flex items-start p-3 rounded-lg hover:bg-accent/10 transition-colors",
      className
    )}
  >
    <div className="mr-2 mt-1 shrink-0">{icon}</div>
    <dl className="min-w-0">
      <dt
        data-test-id={label}
        className="text-sm text-muted-foreground group-hover:text-foreground transition-colors"
      >
        {label}
      </dt>
      <dd
        data-test-id={`${label}-value`}
        className="font-medium wrap-break-word"
      >
        {value}
      </dd>
    </dl>
  </div>
);

/** Section heading that groups related {@link InfoItem}s. */
export const SectionTitle = ({ children }: { children: ReactNode }) => (
  <h3 className="text-xl font-semibold tracking-tight mb-4">{children}</h3>
);
